import { globalStyles } from 'shared/constants';
const { margin, padding, text, display, flex } = globalStyles;

const uploadStyles = {
  paper: {
    ...padding(4),
  },
  title: {
    ...text.weight.bold,
    ...margin(2, 'Bottom')
  },
  progressBar: {
    backgroundColor: 'grey.200',
  },
  accordionPaper: {
    backgroundColor: 'transparent',
    '& .MuiAccordionSummary-content': {
      flexGrow: 0,
    }
  },
};

export default uploadStyles;
